import React from "react";
import PropTypes from "prop-types";

import Money from "components/Money";

import { useOnboardingStepsData } from "scenes/Onboarding/components/OnboardingStepsProvider";

import { Coupon } from "./components";

export function BillSummary({
  currency,
  billedToday,
  billingPeriod,
  monthlyPrice,
  isTrial,
}) {
  const { store } = useOnboardingStepsData();

  return (
    <React.Fragment>
      <div
        data-test="price-info-container"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          rowGap: "20px",
          marginTop: "20px",
        }}
      >
        <b>Regular Price</b>
        <span style={{ justifySelf: "end" }} data-test="regular-price">
          <Money currency={currency}>{monthlyPrice}</Money>
          /month
          {` (billed ${billingPeriod})`}
        </span>
      </div>
      <Coupon currency={currency} />

      <div
        data-test="billing-info-container"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          rowGap: "20px",
          marginTop: "20px",
        }}
      >
        <b>Billed today</b>
        <b style={{ justifySelf: "end" }} data-test="billed-today">
          <Money currency={currency}>
            {isTrial
              ? billedToday
              : store.subscription?.discountedBillingPrice?.total ||
                billedToday}
          </Money>
        </b>
        {isTrial && (
          <React.Fragment>
            <span>Billed after trial</span>
            <span
              style={{ justifySelf: "end" }}
              data-test="billed-after-trial-price"
            >
              <Money currency={currency}>
                {store.subscription?.discountedBillingPrice?.monthly ||
                  monthlyPrice}
              </Money>
              /month
              {` (billed ${billingPeriod})`}
            </span>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
}

BillSummary.propTypes = {
  monthlyPrice: PropTypes.string.isRequired,
  billedToday: PropTypes.string.isRequired,
  billingPeriod: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  isTrial: PropTypes.bool.isRequired,
};

BillSummary.defaultProps = {};

export default BillSummary;
